/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {adminListPoolParticipants} from '../api'

export const useMutationAdminListPoolParticipants = createReactQueryMutationHook('adminListPoolParticipants', adminListPoolParticipants)
